import cash_collection from './cash-collections'
import getBodySettings from "../global/page-settings";

const {nameArea, nameController, nameAction, namePage} = getBodySettings('page');

export default function(){
    if(namePage === 'cashcollectionforecasting') cash_collection();
}